import {CHANGE_CALENDAR} from '../actions/Calendar';

const initialState = {
    type: "Solar Hejri"
};


const CalendarReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_CALENDAR:
            return {
                type: action.payload.type
            };
        default:
            return state;
    }
};


export default CalendarReducer;
